import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { createForm } from 'rc-form'
import { format } from 'date-fns'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button'
import OutlinedInput from '@material-ui/core/OutlinedInput';
import NativeSelect from '@material-ui/core/NativeSelect';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import ResultAlert from 'components/dialog/ResultAlert'
import Loading from 'components/Loading'

import { cleanWineReservationStatus } from '../actions/wines'
import { createReservation } from '../actions/asyncWines'

const FormField = props => (
	<Grid item style={{ marginBottom: '40px' }}>
		<Typography>{props.label}</Typography>
		<Typography className="text-grey" style={{ fontSize: '12px' }}>{props.labelTip}</Typography>
		<Grid style={{ marginTop: '15px' }}>
			{props.children}
		</Grid>
		{props.requiredTip &&
			<Typography color="error" style={{ fontSize: '12px' }}>{props.requiredTip}</Typography>
		}
	</Grid>
)

const ReservationForm = props => {
	const defaultValues = {
		isTrade: 'true',
		deliveryType: 'personally',
		arrivedTime: 'forenoon',
	}
	const { t } = useTranslation()
	const [formData, setFormData] = useState(defaultValues)
	const [showAlert, setShowAlert] = useState(false)
	const { form, createReservationSucc, isLoading, cleanWineReservationStatus } = props
	const { getFieldProps, getFieldError, validateFields } = form

	const handelAlert = () => {
		setShowAlert(!showAlert)
	}

	useEffect(() => {
		return () => {
			cleanWineReservationStatus()
		}
	}, []);

	// create reservation succ show alert
	useEffect(() => {
		if(createReservationSucc) {
			handelAlert()
		}
  }, [createReservationSucc]);

	const onSubmit = () => {
		validateFields((error, value) => {
			if (!error) {
				const query = Object.assign(value, formData)
				if (query['isTrade']) {
					query['isTrade'] = Boolean(query['isTrade'])
				}
				props.createReservation(query)
			}
		})
	}

	const radioChange = (event, value) => {
		setFormData({
			...formData,
			[event.target.name]: value
		})
	}

	const quantityErr = getFieldError('quantity')

	return (
		<Grid container item xs={9}
			justify="center" direction="column"
			style={{
				borderTop: '1px solid rgba(74, 79, 85, 0.2)',
				paddingTop: '40px',
			}}
		>
			<Loading isLoading={isLoading} />
			<Typography variant="h2" style={{ textAlign: 'center' }}>{t('by_order')}</Typography>

			<FormField
				label={t('quantity_label')}
				labelTip={t('quantity_label_tip')}
				requiredTip={t('required')}
			>
				<Input
					inputProps={{
						...getFieldProps('quantity', {
							initialValue: '',
							rules: [{
								required: true,
								type: 'string',
								pattern: /^[0-9]+$/,
							}],
						})
					}}
					error={!!quantityErr}
				/>
			</FormField>

			<FormField
				label={t('referrak_label')}
				labelTip={t('referrak_label_tip')}
			>
				<Input
					placeholder={t('referrak_placeholder')}
					inputProps={{
						...getFieldProps('referral', {
							initialValue: '',
							rules: [{
								type: 'string',
							}],
						})
					}}
				/>
			</FormField>

			<FormField
				label={t('store_period_label')}
				labelTip={t('store_period_label_tip')}
			>
				<NativeSelect
					input={
						<OutlinedInput />
					}
					inputProps={{
						...getFieldProps('storePeriod', {
							initialValue: `${t('one_month')}`,
						})
					}}
				>
					<option value={t('one_month')}>{t('one_month')}</option>
					<option value={t('two_month')}>{t('two_month')}</option>
					<option value={t('three_month')}>{t('three_month')}</option>
					<option value={t('four_month')}>{t('four_month')}</option>
					<option value={t('five_month')}>{t('five_month')}</option>
					<option value={t('half_year')}>{t('half_year')}</option>
					<option value={t('half_to_one_year')}>{t('half_to_one_year')}</option>
					<option value={t('over_one_year')}>{t('over_one_year')}</option>
					<option value={t('not_sure')}>{t('not_sure')}</option>
				</NativeSelect>
			</FormField>

			<FormField
				label={t('trade_label')}
				labelTip={t('trade_label_tip')}
			>
				{/* isTrade */}
				<RadioGroup
					className="intro-radio"
					onChange={radioChange}
					name="isTrade"
					aria-label="isTrade"
					defaultValue={defaultValues.isTrade}
				>
					<FormControlLabel
						value={'true'}
						control={<Radio color="primary" />}
						label={t('yes')}
					/>
					<FormControlLabel
						value={'false'}
						control={<Radio color="primary" />}
						label={t('no')}
					/>
				</RadioGroup>
			</FormField>

			<FormField
				label={t('delivery_type_lable')}
				labelTip={t('delivery_type_lable_tip')}
			>
				{/* deliveryType */}
				<RadioGroup className="intro-radio"
					onChange={radioChange}
					name="deliveryType"
					aria-label="deliveryType"
					defaultValue={defaultValues.deliveryType}
				>
					<FormControlLabel
						value={'personally'}
						control={<Radio color="primary" />}
						label={t('delivery_type_1')}
					/>
					<FormControlLabel
						value={'logistics'}
						control={<Radio color="primary" />}
						label={t('delivery_type_2')}
					/>
				</RadioGroup>
			</FormField>

			<FormField
				label={t('arrived_date_label')}
				labelTip={t('arrived_date_label_tip')}
			>
				<Input
					type="date"
					inputProps={{
						...getFieldProps('arrivedDate', {
							initialValue: '',
							placeholder: 'YYYY / MM / DD',
							rules: [{
								type: "string"
							}],
						}),
						min: format(new Date(), 'yyyy-MM-dd')
					}}
				/>
			</FormField>

			<FormField
				label={t('arrived_time_label')}
			>
				{/* arrivedTime */}
				<RadioGroup className="intro-radio"
					onChange={radioChange}
					name="arrivedTime"
					aria-label="arrivedTime"
					defaultValue={defaultValues.arrivedTime}
				>
					<FormControlLabel
						value={'forenoon'}
						control={<Radio color="primary" />}
						label={t('arrived_time_1')}
					/>
					<FormControlLabel
						value={'afternoon'}
						control={<Radio color="primary" />}
						label={t('arrived_time_2')}
					/>
				</RadioGroup>
			</FormField>

			<Grid item>
				<Button color="primary" variant="contained" onClick={onSubmit}>
					{t('send_order')}
				</Button>
			</Grid>
			<ResultAlert
				open={showAlert}
				onClose={handelAlert}
			/>
		</Grid>
	)
}

const mapStateToProps = state => ({
	isLoading: state.wines.isLoading,
	createReservationSucc: state.wines.createReservationSucc,
})

const mapDispatchToProps = {
	createReservation,
	cleanWineReservationStatus,
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(createForm()(ReservationForm))
